import Vue from "vue";
import axios from "axios";
import { Toast } from 'vant';

axios.defaults.timeout = 60000;
axios.defaults.baseURL = "https://nahan.zhixinxinli888.com/index/index/"; //填写域名
// axios.defaults.baseURL = "https://nahan.zkyx.net/index/index/"; //填写域名
// axios.defaults.baseURL = "http://127.0.0.1/index/index/"; //填写域名

//http request 拦截器
axios.interceptors.request.use(
  config => {
    config.data = config.data;
    config.headers = {
      "Content-Type": "application/x-www-form-urlencoded"
    };
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

//响应拦截器即异常处理
axios.interceptors.response.use(
  response => {
    return response;
  },
  err => {
    if (err && err.response) {
      switch (err.response.status) {
        case 400:
          Toast.fail("错误请求")
          break;
        case 401:
          Toast.fail("未授权，请重新登录")
          break;
        case 403:
          Toast.fail("拒绝访问")
          break;
        case 404:
          Toast.fail("请求错误,未找到该资源")
          break;
        case 405:
          Toast.fail("请求方法未允许")
          break;
        case 408:
          Toast.fail("请求超时")
          break;
        case 500:
          Toast.fail("服务器端出错")
          break;
        case 501:
          Toast.fail("网络未实现")
          break;
        case 502:
          Toast.fail("网络错误")
          break;
        case 503:
          Toast.fail("服务不可用")
          break;
        case 504:
          Toast.fail("网络超时")
          break;
        case 505:
          Toast.fail("http版本不支持该请求")
          break;
        default: 
        // `连接错误${err.response.status}`
          Toast.fail("连接错误")
      }
    } else {
      Toast.fail("连接到服务器失败")
    }
    return Promise.resolve(err.response);
  }
);

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function get(url, params = {}) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params
      })
      .then(response => {
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });
}

/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function post(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.post(url, data).then(
      response => {
        resolve(response.data);
      },
      err => {
        reject(err);
      }
    );
  });
}

/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function patch(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.patch(url, data).then(
      response => {
        resolve(response.data);
      },
      err => {
        reject(err);
      }
    );
  });
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.put(url, data).then(
      response => {
        resolve(response.data);
      },
      err => {
        reject(err);
      }
    );
  });
}
